module.exports = __webpack_public_path__ + "static/medusa-bc0e7989bbc601705bef804d00c9fa36.jpeg";